import http from "../../http";

const userAction = {

    queryUserAction(r) {
        return  http.get("/gateway/api/bi/manage/userAction/queryUserAction",r )
    },
}
export default userAction
